import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  instructorNameLabel: {
    id: 'course-authoring.schedule-section.instructor.name.label',
    defaultMessage: 'Name',
  },
  instructorNameHelpText: {
    id: 'course-authoring.schedule-section.instructor.name.help-text',
    defaultMessage: 'Please add the instructor\'s name',
  },
  instructorNameInputPlaceholder: {
    id: 'course-authoring.schedule-section.instructor.name.input.placeholder',
    defaultMessage: 'Instructor name',
  },
  instructorTitleLabel: {
    id: 'course-authoring.schedule-section.instructor.title.label',
    defaultMessage: 'Title',
  },
  instructorTitleHelpText: {
    id: 'course-authoring.schedule-section.instructor.title.help-text',
    defaultMessage: 'Please add the instructor\'s title',
  },
  instructorTitleInputPlaceholder: {
    id: 'course-authoring.schedule-section.instructor.title.input.placeholder',
    defaultMessage: 'Instructor title',
  },
  instructorOrganizationLabel: {
    id: 'course-authoring.schedule-section.instructor.organization.label',
    defaultMessage: 'Organization',
  },
  instructorOrganizationHelpText: {
    id: 'course-authoring.schedule-section.instructor.organization.help-text',
    defaultMessage: 'Please add the institute where the instructor is associated',
  },
  instructorOrganizationInputPlaceholder: {
    id: 'course-authoring.schedule-section.instructor.organization.input.placeholder',
    defaultMessage: 'Instructor organization',
  },
  instructorBioLabel: {
    id: 'course-authoring.schedule-section.instructor.bio.label',
    defaultMessage: 'Biography',
  },
  instructorBioHelpText: {
    id: 'course-authoring.schedule-section.instructor.bio.help-text',
    defaultMessage: 'Please add the instructor\'s biography',
  },
  instructorBioInputPlaceholder: {
    id: 'course-authoring.schedule-section.instructor.bio.input.placeholder',
    defaultMessage: 'Instructor biography',
  },
  instructorPhotoLabel: {
    id: 'course-authoring.schedule-section.instructor.photo.label',
    defaultMessage: 'Photo',
  },
  instructorPhotoHelpText: {
    id: 'course-authoring.schedule-section.instructor.photo.help-text',
    defaultMessage: 'Please add a photo of the instructor (Note: only JPEG or PNG format supported)',
  },
  instructorPhotoInputPlaceholder: {
    id: 'course-authoring.schedule-section.instructor.photo.input.placeholder',
    defaultMessage: 'Instructor photo URL',
  },
  instructorDelete: {
    id: 'course-authoring.schedule-section.instructor.delete',
    defaultMessage: 'Delete',
  },
});

export default messages;
